import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import DropdownIndicatorPart from './parts/DropdownIndicatorPart';
import OptionPart from './parts/OptionPart';

import classes from './SelectCustom.module.scss';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    height: '40px',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    border: 'none',
    outline: 'none',
    boxShadow: '0px 2px 10px rgba(221, 226, 241, 0.6)'
  }),

  singleValue: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: '400',
    color: '#4D4476'
  }),

  menu: (provided, state) => ({
    ...provided,
    borderRadius: '4px',
    boxShadow: '0px 2px 10px rgba(221, 226, 241, 0.6)'
  }),

  option: (provided, state) => ({
    ...provided,
    padding: '10px 16px',
    height: '40px',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: state.isSelected ? '500' : '400',
    color: '#4D4476',
    backgroundColor:
      state.isFocused || state.isSelected ? '#FBFBFB' : '#FFFFFF',
    ':active': {
      backgroundColor: '#FBFBFB'
    }
  })
};

const SelectCustom = ({ selectTitle, value, onChange, options }) => {
  return (
    <div>
      <p className={classes.selectTitle}>{selectTitle}</p>
      <Select
        value={value}
        onChange={onChange}
        options={options}
        styles={customStyles}
        components={{
          DropdownIndicator: DropdownIndicatorPart,
          IndicatorSeparator: null,
          Option: OptionPart
        }}
      />
    </div>
  );
};

SelectCustom.propTypes = {
  selectTitle: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired
};

export default SelectCustom;
